import { Typography, Box } from "@mui/material";
import CardReferenceTag from "../common/CardReferenceTag";

interface HomeTitleCardProps {
  title?: string;
  description?: string;
  startDate?: string;
  endDate?: string;
}

const HomeTitleCard: React.FC<HomeTitleCardProps> = ({
  title,
  description,
  startDate,
  endDate,
}) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
      <CardReferenceTag
        color="red"
        tooltip="Main report information, used for identification"
      />
      <Typography sx={{mt:1}} variant="h5">
        <strong>{title ?? "-"}</strong>
      </Typography>
      <Typography variant="body1">{description ?? "-"}</Typography>
      <Typography variant="body1">
        <strong>Period:</strong> {startDate ?? "-"} / {endDate ?? "-"}{" "}
      </Typography>
    </Box>
  );
};

export default HomeTitleCard;
